// Setup production environment configurations
if (process.env.NODE_ENV === 'production') {
  // Disable console logs in production
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for important issues
} 